import React from 'react';
import PropTypes from 'prop-types';

SkillButton.propTypes = {
    selected: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.any
};

function SkillButton(props)
{
    let {
        selected,
        name,
        onChange,
        isDisabled
    } = props;
    return (

        <div onClick={() => {
            if (!isDisabled && onChange) {
                onChange()
            }
        }} className={TB.mapClass("skill", {
            "disabled": isDisabled,
            selected
        })}>

            <p>{name}</p>

            <div className="s-divider"/>

            <i className={selected ? 'fa fa-minus' : 'fa fa-plus'}/>
        </div>
    );
}

export default SkillButton;
